import React from "react";
import { AuthProvider } from "./auth-context";
import { Router } from "react-router-dom";
import history from "utils/history";

function AppProviders({ children }) {
  return (
    <Router history={history}>
      <AuthProvider>{children}</AuthProvider>
    </Router>
  );
}

export default AppProviders;
